import da from 'date-fns/locale/da'
import en from 'date-fns/locale/en-GB'
import fi from 'date-fns/locale/fi'
import nb from 'date-fns/locale/nb'
import sv from 'date-fns/locale/sv'

import { Locale } from '@bemlo/enums'

// Note: date-fns formats are not compatible with DayJs formats
export const DATE_FNS_LOCALE_OPTIONS = {
  [Locale.DA]: {
    dateFormat: {
      long: 'D. MMMM YYYY',
      short: 'DD.MM.YYYY',
    },
    locale: da,
  },
  [Locale.EN]: {
    dateFormat: {
      long: 'd MMM yyyy',
      short: 'd MMM yy',
    },
    locale: en,
  },
  [Locale.FI]: {
    dateFormat: {
      long: 'D. MMMM[ta] YYYY',
      short: 'D.M.YYYY',
    },
    locale: fi,
  },
  [Locale.NB]: {
    dateFormat: {
      long: "d'.' MMM yyyy ('uke 'w)",
      short: 'd.M.yyyy',
    },
    locale: nb,
  },
  [Locale.SV]: {
    dateFormat: {
      long: "d MMM yyyy ('v'w)",
      short: 'd/M yyyy',
    },
    locale: sv,
  },
}
